import { Box, Typography } from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch } from '../../store/store'
import { getEmergingAlertHighlights, selectEmergingAlertHighlights, selectIfAlertHighlightsLoading } from '../../store/slices/emergingAlertsSlice';
import { useEffect } from 'react';
import MetricForLocationBackground from '../../assets/metric-2.svg'
import MetricBackground from '../../assets/metric.svg'
import { SHOW_HIGHLIGHS_ONLY } from '../../constants/AlertHlightsViewings';
import AdnocLoadingProgress from '../shared/AdnocLoadingProgress';


export default function AlertHighlights() {

    const dispatch = useDispatch<AppDispatch>();

    const isAlertHighlightsLoading = useSelector(selectIfAlertHighlightsLoading);
    const highlights = useSelector(selectEmergingAlertHighlights);

    useEffect(() => {
        if (isAlertHighlightsLoading === null)
            dispatch(getEmergingAlertHighlights())
    }, [dispatch, isAlertHighlightsLoading])

    return (
        <>
            {
                (isAlertHighlightsLoading === null || isAlertHighlightsLoading === true)
                && <Box sx={{
                    gridColumn: '1/-1',
                    width: '100%',
                    padding: 1,
                }}>
                    <Typography variant='h6'>
                        Deviation Radar Highlights
                    </Typography>
                    <Box component={'div'} sx={{
                        marginTop: 2,
                        display: 'grid',
                        placeContent: 'center'
                    }}>
                        <AdnocLoadingProgress></AdnocLoadingProgress>
                    </Box>
                </Box>
            }
            {
                highlights.length > 0 && highlights.filter((ah: any) => SHOW_HIGHLIGHS_ONLY.includes(ah.heading_name)).map((ah: any, index: number) => {
                    const background = isNaN(ah.description) ? `url(${MetricBackground}) no-repeat` : `url(${MetricForLocationBackground}) no-repeat`
                    return <Box
                        key={index}
                        sx={{
                            height: '100%',
                            width: '100%',
                            boxSizing: 'border-box',
                            background: background,
                            backgroundPosition: 'center',
                            backgroundSize: '100%',
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            alignItems: 'end',
                            rowGap: 1,
                            paddingRight: 2,
                            '& > *': {
                                width: '75%',
                                lineHeight: '1.1 !important',
                            }
                        }}>
                        <Typography variant="body2"  fontWeight={500} textAlign={'left'}>
                            {ah.heading_name}
                        </Typography>
                        <Typography variant="subtitle1" className="text_primary_gradient" sx={{
                            textAlign: 'left'
                        }}>
                            {ah.description}
                        </Typography>
                    </Box>
                })
            }
        </>
    )
}
